
import React, { useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    IconButton,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    useMediaQuery,
} from "@mui/material";
import { Building, ClipboardList, Anchor, Ship } from "lucide-react";
import ShareIcon from "@mui/icons-material/Share";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate, useSearchParams } from "react-router-dom";

import toast from "react-hot-toast";
import HistoryIcon from "@mui/icons-material/History";
import VesselDeatils from "./VesselDetails";

function OceanTrackingHeader({ oceanTrackList, vesselDetail }: { oceanTrackList: any, vesselDetail: any[] }) {
    const isMobile = useMediaQuery("(max-width:600px)");
    return <div className="whiteBox whiteBoxCustom padding10">
        <Box component="form" noValidate autoComplete="off">
            <div className="grid 2xl:grid-cols-12 xl:grid-cols-12 lg:grid-cols-12 md:grid-cols-12 sm:grid-cols-12 gap-3">
                <div className="2xl:col-span-3 xl:col-span-3 lg:col-span-3 md:col-span-4 sm:col-span-6">
                    <div className="flex trackinglist userTrackList mb-2">
                        <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full border border-yellow-200 p-1 flex justify-center item-center center">
                            <ClipboardList className="text-yellow-400" />
                        </figure>
                        <aside className="ml-2 w-full">
                            <TextField
                                id="ocean-number"
                                label="Tracking Number"
                                defaultValue={oceanTrackList?.trackingNumber || ""}
                                value={oceanTrackList?.trackingNumber || ""}
                                InputLabelProps={{ shrink: true }}
                                slotProps={{ input: { readOnly: true } }}
                                fullWidth
                            />
                        </aside>
                    </div>{" "}
                </div>
                <div className="2xl:col-span-3 xl:col-span-3 lg:col-span-3 md:col-span-4 sm:col-span-6">
                    <div className="flex trackinglist userTrackList mb-2">
                        <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full border border-yellow-200 p-1 flex justify-center item-center center">
                            <Building className="text-yellow-400" />
                        </figure>
                        <aside className="ml-2 w-full">
                            <TextField
                                id="type"
                                label="Type"
                                sx={
                                    isMobile
                                        ? {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                            width: "90% !important",
                                        }
                                        : {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                        }
                                }
                                defaultValue={oceanTrackList?.type || ""}
                                value={oceanTrackList?.type || ""}
                                InputLabelProps={{ shrink: true }}
                                slotProps={{ input: { readOnly: true } }}
                                fullWidth
                            />
                        </aside>
                    </div>{" "}
                </div>
                <div className="2xl:col-span-3 xl:col-span-3 lg:col-span-3 md:col-span-4 sm:col-span-6">
                    <div className="flex trackinglist userTrackList mb-2">
                        <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full border border-yellow-200 p-1 flex justify-center item-center center">
                            <Anchor className="text-yellow-400" />
                        </figure>
                        <aside className="ml-2 w-full">
                            <TextField
                                id="carrier-code"
                                label="Carrier Code"
                                sx={
                                    isMobile
                                        ? {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                            width: "90% !important",
                                        }
                                        : {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                        }
                                }
                                defaultValue={oceanTrackList?.carrierCode || ""}
                                value={oceanTrackList?.carrierCode || ""}
                                InputLabelProps={{ shrink: true }}
                                slotProps={{ input: { readOnly: true } }}
                                fullWidth
                            />
                        </aside>
                    </div>{" "}
                </div>
                <div className="2xl:col-span-3 xl:col-span-3 lg:col-span-3 md:col-span-4 sm:col-span-6">
                    <div className="flex trackinglist userTrackList mb-2">
                        <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full border border-yellow-200 p-1 flex justify-center item-center center">
                            <Ship className="text-yellow-400" />
                        </figure>
                        <aside className="ml-2 w-full">
                            <TextField
                                id="carrier-name"
                                label="Carrier Name"
                                sx={
                                    isMobile
                                        ? {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                            width: "90% !important",
                                        }
                                        : {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                        }
                                }
                                defaultValue={oceanTrackList?.carrierName || ""}
                                value={oceanTrackList?.carrierName || ""}
                                InputLabelProps={{ shrink: true }}
                                slotProps={{ input: { readOnly: true } }}
                                fullWidth
                            />
                        </aside>
                    </div>{" "}
                </div>
                <div className="2xl:col-span-3 xl:col-span-3 lg:col-span-3 md:col-span-4 sm:col-span-6">
                    <div className="flex trackinglist userTrackList mb-2">
                        <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full border border-yellow-200 p-1 flex justify-center item-center center">
                            <img
                                src="/images/notebook-tabs.svg"
                                alt="vessel count"
                            />
                        </figure>
                        <aside className="ml-2 w-full">
                            <TextField
                                id="vessel-count"
                                label="Vessel Count"
                                sx={
                                    isMobile
                                        ? {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                            width: "90% !important",
                                        }
                                        : {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                        }
                                }
                                defaultValue={oceanTrackList?.vessalCount || ""}
                                value={oceanTrackList?.vessalCount || ""}
                                InputLabelProps={{ shrink: true }}
                                slotProps={{ input: { readOnly: true } }}
                                fullWidth
                            />
                        </aside>
                    </div>{" "}
                </div>{" "}
                <div className="2xl:col-span-3 xl:col-span-3 lg:col-span-3 md:col-span-4 sm:col-span-6">
                    <div className="flex trackinglist userTrackList mb-2">
                        <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full border border-yellow-200 p-1 flex justify-center item-center center">
                            <img src="/images/boxes.svg" alt="container count" />
                        </figure>
                        <aside className="ml-2 w-full">
                            <TextField
                                id="container-count"
                                label="Container Count"
                                sx={
                                    isMobile
                                        ? {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                            width: "90% !important",
                                        }
                                        : {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                        }
                                }
                                defaultValue={oceanTrackList?.containerCount || ""}
                                value={oceanTrackList?.containerCount || ""}
                                InputLabelProps={{ shrink: true }}
                                slotProps={{ input: { readOnly: true } }}
                                fullWidth
                            />
                        </aside>
                    </div>{" "}
                </div>{" "}
                <div className="2xl:col-span-3 xl:col-span-3 lg:col-span-3 md:col-span-4 sm:col-span-6">
                    <div className="flex trackinglist userTrackList mb-2">
                        <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full border border-yellow-200 p-1 flex justify-center item-center center">
                            <img
                                src="/images/scroll-text.svg"
                                alt="place of receipt"
                            />
                        </figure>
                        <aside className="ml-2 w-full">
                            <TextField
                                id="place-of-receipt"
                                label="Place Of Receipt"
                                sx={
                                    isMobile
                                        ? {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                            width: "90% !important",
                                        }
                                        : {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                        }
                                }
                                defaultValue={oceanTrackList?.placeOfReceipt || ""}
                                value={oceanTrackList?.placeOfReceipt || ""}
                                InputLabelProps={{ shrink: true }}
                                slotProps={{ input: { readOnly: true } }}
                                fullWidth
                            />
                        </aside>
                    </div>{" "}
                </div>{" "}
                <div className="2xl:col-span-3 xl:col-span-3 lg:col-span-3 md:col-span-4 sm:col-span-6">
                    <div className="flex trackinglist userTrackList mb-2">
                        <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full border border-yellow-200 p-1 flex justify-center item-center center">
                            <img
                                src="/images/package-check.svg"
                                alt="port of origin"
                            />
                        </figure>
                        <aside className="ml-2 w-full">
                            <TextField
                                id="port-of-origin"
                                label="Port Of Origin"
                                sx={
                                    isMobile
                                        ? {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                            width: "90% !important",
                                        }
                                        : {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                        }
                                }
                                defaultValue={
                                    `${oceanTrackList?.portOfOriginCode||""} – ${oceanTrackList?.portOfOrigin||""}` ||
                                    ""
                                }
                                value={
                                    `${oceanTrackList?.portOfOriginCode||""} – ${oceanTrackList?.portOfOrigin||""}` ||
                                    ""
                                }
                                InputLabelProps={{ shrink: true }}
                                slotProps={{ input: { readOnly: true } }}
                                fullWidth
                            />
                        </aside>
                    </div>{" "}
                </div>{" "}
                <div className="2xl:col-span-3 xl:col-span-3 lg:col-span-3 md:col-span-4 sm:col-span-6">
                    <div className="flex trackinglist userTrackList mb-2">
                        <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full border border-yellow-200 p-1 flex justify-center item-center center">
                            <img
                                src="/images/package-check.svg"
                                alt="place of delivery"
                            />
                        </figure>
                        <aside className="ml-2 w-full">
                            <TextField
                                id="place-of-delivery"
                                label="Place of Delivery"
                                sx={
                                    isMobile
                                        ? {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                            width: "90% !important",
                                        }
                                        : {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                        }
                                }
                                defaultValue={oceanTrackList?.placeOfDelivery || ""}
                                value={oceanTrackList?.placeOfDelivery || ""}
                                InputLabelProps={{ shrink: true }}
                                slotProps={{ input: { readOnly: true } }}
                                fullWidth
                            />
                        </aside>
                    </div>{" "}
                </div>{" "}
                <div className="2xl:col-span-3 xl:col-span-3 lg:col-span-3 md:col-span-4 sm:col-span-6">
                    <div className="flex trackinglist userTrackList mb-2">
                        <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full border border-yellow-200 p-1 flex justify-center item-center center">
                            <img
                                src="/images/forklift.svg"
                                alt="Port of discharge"
                            />
                        </figure>
                        <aside className="ml-2 w-full">
                            <TextField
                                id="port-of-discharge"
                                label="Port Of Discharge"
                                sx={
                                    isMobile
                                        ? {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                            width: "90% !important",
                                        }
                                        : {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                        }
                                }
                                defaultValue={
                                    `${oceanTrackList?.portOfDischargeCode||""} – ${oceanTrackList?.portOfDischarge||""}` ||
                                    ""
                                }
                                value={
                                    `${oceanTrackList?.portOfDischargeCode||""} – ${oceanTrackList?.portOfDischarge||""}` ||
                                    ""
                                }
                                InputLabelProps={{ shrink: true }}
                                slotProps={{ input: { readOnly: true } }}
                                fullWidth
                            />
                        </aside>
                    </div>{" "}
                </div>{" "}
                <div className="2xl:col-span-5  xl:col-span-5 lg:col-span-5 md:col-span-8 sm:col-span-12">
                    <div className="flex trackinglist userTrackList mb-2">
                        <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full border border-yellow-200 p-1 flex justify-center item-center center">
                            <img
                                src="/images/shield-check.svg"
                                alt="last activity"
                            />
                        </figure>
                        <aside className="ml-2 w-full">
                            <TextField
                                id="last-activity"
                                label="Last Activity"
                                sx={
                                    isMobile
                                        ? {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                            width: "90% !important",
                                        }
                                        : {
                                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                        }
                                }
                                defaultValue={
                                    oceanTrackList?.currentStatus &&
                                        (oceanTrackList.currentStatus.date ||
                                            oceanTrackList.currentStatus.milestone ||
                                            oceanTrackList.currentStatus.portName)
                                        ? `${oceanTrackList.currentStatus.date
                                            ? `${oceanTrackList.currentStatus.date} - `
                                            : ""
                                        }${oceanTrackList.currentStatus.milestone || ""
                                        }${oceanTrackList.currentStatus.portName
                                            ? `, ${oceanTrackList.currentStatus.portName}`
                                            : ""
                                        }`
                                        : ""
                                }
                                value={
                                    oceanTrackList?.currentStatus &&
                                        (oceanTrackList.currentStatus.date ||
                                            oceanTrackList.currentStatus.milestone ||
                                            oceanTrackList.currentStatus.portName)
                                        ? `${oceanTrackList.currentStatus.date
                                            ? `${oceanTrackList.currentStatus.date} - `
                                            : ""
                                        }${oceanTrackList.currentStatus.milestone || ""
                                        }${oceanTrackList.currentStatus.portName
                                            ? `, ${oceanTrackList.currentStatus.portName}`
                                            : ""
                                        }`
                                        : ""
                                }
                                InputLabelProps={{ shrink: true }}
                                slotProps={{ input: { readOnly: true } }}
                                fullWidth
                            />
                        </aside>
                    </div>
                </div>
                <VesselDeatils vesselDetail={vesselDetail} />
            </div>
        </Box>
    </div>

}
export default OceanTrackingHeader;